<template>
  <vxe-column v-if="isMethodDefault(field.show, {}, true)" :key="field.rewriteKey ? field.rewriteKey : field.key"
    :type="field.type" :field="field.key" :title="isMethod(field.name)"
    :show-overflow="field.showOverflow ? true : field.showOverflow" :fixed="field.fixed" :cell-render="field.cellRender"
    :min-width="field.minWidth" :width="$page.isMethod(field.width, { field })" v-bind="field.columnBind"
    :align="field.align" :headerAlign="field.headerAlign || 'center'" :params="{
      headerClass: field.headerClass,
      parentHeaderClass: field.parentHeaderClass,
    }">
    <template v-if="field.expandRender" #content="{ row, rowIndex }">
      <TableExpand :row="row" :index="rowIndex" :render="field.expandRender" v-bind="field.bind"></TableExpand>
    </template>
    <template v-if="!['checkbox', 'seq'].includes(field.type)" #header="{ row, rowIndex, column, columnIndex }">
      <span v-if="field.required && config.form" style="color: red">*</span>
      <template v-if="field.header && field.header.render">
        <TableExpand :row="row" :index="rowIndex" :column="column" :columnIndex="columnIndex"
          :render="field.header.render" v-bind="field.bind"></TableExpand>
      </template>
      <template v-else-if="field.header && field.header.spanTitle">
        <div style="display: flex; justify-content: center; align-items: center">
          <span>{{ isMethod(field.name) }}</span>
          <span style="color: red; margin-top: -22px"> -0 </span>
        </div>
      </template>
      <component v-else-if="field.header && field.header.component" :is="isMethod(field.header.component)"
        v-model="field.header.value" :row="row" :column="column" :columnIndex="columnIndex" v-bind="field.header.bind"
        v-on="field.header.on" :min="isMethod(field.header.bind && field.header.bind.min, {
          column,
          columnIndex,
          field: field.header,
        })
          " :max="isMethod(field.header.bind && field.header.bind.max, {
    column,
    columnIndex,
    field: field.header,
  })
    " :disabled="isMethod(field.disabled, {
    column,
    columnIndex,
    field: field.header,
  })
    " :placeholder="handlePlaceholder(field, {
    column,
    columnIndex,
    field: field.header,
  })
    " @click="
    handleMethod({
      methods: field.header.methods,
      name: field.fnName || 'click',
      column,
      columnIndex,
      field: field.header,
    })
    " @on-enter="
    handleMethod({
      methods: field.header.methods,
      name: 'on-enter',
      column,
      columnIndex,
      field: field.header,
    })
    " @on-focus="
    handleMethod({
      methods: field.header.methods,
      name: 'on-focus',
      column,
      columnIndex,
      field: field.header,
    })
    " @on-blur="
    handleMethod({
      methods: field.header.methods,
      name: 'on-blur',
      column,
      columnIndex,
      field: field.header,
    })
    " @on-change="
    handleMethod({
      methods: field.header.methods,
      name: 'on-change',
      column,
      columnIndex,
      field: field.header,
    })
    " @on-ok="
    handleMethod({
      methods: field.header.methods,
      name: 'on-ok',
      column,
      columnIndex,
      field: field.header,
    })
    " @on-input="
    handleMethod({
      methods: field.header.methods,
      name: 'on-input',
      column,
      columnIndex,
      field: field.header,
    })
    " @on-clear="
    handleMethod({
      methods: field.header.methods,
      name: 'on-clear',
      column,
      columnIndex,
      field: field.header,
    })
    " @on-select="
    handleMethod({
      methods: field.header.methods,
      name: 'on-select',
      column,
      columnIndex,
      field: field.header,
    })
    " @on-click="
    handleMethod({
      methods: field.header.methods,
      name: 'on-click',
      column,
      columnIndex,
      field: field.header,
    })
    "></component>
      <span v-else style="word-break: break-word">{{
        isMethod(field.name)
      }}</span>
      <template v-if="field.header && field.header.copy">
        <Button @click="allCopy({ row, field, noFilter: field.header.noFilter })" v-bind="field.copyBind" icon="md-copy"
          size="small" style="margin-left: 5px; margin-top: -3px" />
      </template>
    </template>
    <template #default="{ row, rowIndex }" v-if="!['checkbox', 'seq', 'html'].includes(field.type) &&
      (!isDeep || field.noDeep)
      ">
      <slot :name="field.slot" :row="row" :value="row[field.key]" :rowIndex="rowIndex" :field="field">
        <component :is="config.form ? 'FormItem' : 'span'" :label-width="0" :style="config.form ? 'padding-top: 5px' : ''"
          :prop="'table.' + rowIndex + '.' + field.key" :rules="{
            required: field.required,
            message: 'can not be empty',
            trigger: 'blur',
            type:
              field.formType ||
              (field.component === 'InputNumber'
                ? 'number'
                : field.component === 'DatePicker'
                  ? 'date'
                  : 'string'),
          }">
          <template v-if="field.type === 'child'">
            <tableColumnChild :row="row[field.child.list]" :field="field" :fields="fields" :parent="row">
            </tableColumnChild>
          </template>
          <template v-else-if="field.type === 'btns'">
            <Dropdown v-if="hasPermission(field.id) && field.down" v-bind="field.bind" transfer @on-click="
              handleDropoDown($event, { fields: field, row, rowIndex })
              ">
              <Button v-bind="field.btnBind">
                {{ isMethod(field.btnName || field.name) }}
                <Icon type="ios-arrow-down"></Icon>
              </Button>
              <DropdownMenu slot="list">
                <template v-for="(btn, index) in field.list">
                  <DropdownItem :name="index" v-if="hasPermission(btn.id)" :key="btn.type">
                    <Button style="width: 100%" v-bind="btn.bind" :disabled="isMethod(btn.disabled, {
                      row,
                      rowIndex,
                      field: btn,
                      btnList: field.list,
                    })
                      " :style="[
    { color: btn.color },
    btn.bind && btn.bind.style,
  ]" size="small" :icon="isMethod(btn.icon, { row, rowIndex, field, fields })
  ">
                      {{ isMethod(btn.name) }}
                      <Icon :type="isMethod(btn.afterIcon, {
                        row,
                        rowIndex,
                        field,
                        fields,
                      })
                        " v-if="btn.afterIcon" />
                    </Button>
                  </DropdownItem>
                </template>
              </DropdownMenu>
            </Dropdown>
            <template v-else>
              <template v-for="(btn, btnIndex) in field.list">
                <template v-if="hasPermission(btn.id) &&
                  isMethodDefault(
                    btn.show,
                    { row, rowIndex, field, fields },
                    true
                  )
                  ">
                  <Dropdown :key="btnIndex" v-if="btn.list" v-bind="btn.bind" transfer @on-click="
                    handleDropoDown($event, {
                      fields: btn,
                      methods: field.methods,
                      row,
                      rowIndex,
                    })
                    ">
                    <Button size="small" style="margin-right: 5px" :disabled="$page.isMethod(btn.disabled, {
                      row,
                      rowIndex,
                      field,
                      fields,
                    })
                      " v-bind="btn.btnBind">
                      {{ isMethod(btn.btnName || btn.name) }}
                      <Icon type="ios-arrow-down"></Icon>
                    </Button>
                    <DropdownMenu v-if="!$page.isMethod(btn.disabled, {
                      row,
                      rowIndex,
                      field,
                      fields,
                    })
                      " slot="list">
                      <template v-for="(childBtn, index) in btn.list">
                        <DropdownItem :name="index" v-if="hasPermission(childBtn.id)" :key="childBtn.type" :disabled="$page.isMethod(childBtn.disabled, {
                          row,
                          rowIndex,
                          field,
                          childBtn,
                          fields,
                        })
                          ">
                          {{ isMethod(childBtn.name) }}
                        </DropdownItem>
                      </template>
                    </DropdownMenu>
                  </Dropdown>
                  <Button v-else style="margin-right: 5px" size="small" @click="
                    $page.handleMethod({
                      methods: field.methods,
                      name: btn.fnName || 'click',
                      field: btn,
                      row,
                      rowIndex,
                    })
                    " :key="btn.type" v-bind="btn.bind" :type="isMethod(btn.bind && btn.bind.type, {
    row,
    rowIndex,
    field: btn,
    btnList: field.list,
  })
    " :disabled="isMethod(btn.disabled, {
    row,
    rowIndex,
    field: btn,
    fields,
    btnList: field.list,
  })
    " :icon="isMethod(btn.icon, { row, rowIndex, field, fields })">
                    {{ isMethod(btn.name, { row, rowIndex, field, fields }) }}
                    <Icon :type="isMethod(btn.afterIcon, {
                      row,
                      rowIndex,
                      field,
                      fields,
                    })
                      " size="14" :color="isMethod(btn.afterIconColor, {
    row,
    rowIndex,
    field,
    fields,
  })
    " v-if="btn.afterIcon" />
                  </Button>
                </template>
              </template>
            </template>
          </template>
          <template v-else-if="isMethod(field.component, {
            field: field,
            row,
            value: row[field.key],
            rowIndex,
          }) === 'Select'
            " @on-select="
              handleMethod({ methods: field.methods, name: 'on-select' })
            ">
            <Select :placeholder="handlePlaceholder(field, { row, field: field })" :disabled="isMethod(field.disabled, {
              field: field,
              row,
              value: row[field.key],
              rowIndex,
            })
              " v-model="row[field.key]" @on-change="
    handleMethod({
      methods: field.methods,
      name: 'on-change',
      field: field,
      value: row[field.key],
      row,
      rowIndex,
    })
    " @on-clear="
    handleMethod({
      methods: field.methods,
      name: 'on-clear',
      field: field,
    })
    " v-bind="field.bind" v-on="field.on" :transfer="field.bind
      ? field.bind.transfer == undefined || config.form
        ? true
        : field.transfer
      : false || config.form
    " :filterable="field.filterable == undefined ? true : field.filterable
    " :filter-by-label="field.filterByLabel == undefined ? true : field.filterByLabel
    " :clearable="field.clearable == undefined ? true : field.clearable">
              <Option v-for="item in field.options" :label="isMethodDefault(
                field.config && field.config.label,
                { field: field, row: item },
                getProp(item, field.config, 'label')
              )
                " :value="getProp(item, field.config, 'value')" :key="isMethodDefault(
    field.config && field.config.value,
    { field: field, row: item },
    getProp(item, field.config, 'key')
  )
    " @click.native="
    handleMethod({
      methods: field.methods,
      name: 'click',
      field: field,
      row: item,
      rowIndex,
    })
    "></Option>
            </Select>
          </template>
          <Cascader v-bind="field.bind" v-else-if="field.component == 'Cascader'" :data="field.options"
            v-model="row[field.key]" :disabled="isMethod(field.disabled, { row, rowIndex, field, fields })
              " :load-data="(item, callback) =>
      handleMethod({
        methods: field.methods,
        name: field.fnName || 'loadData',
        row,
        rowIndex,
        field,
        fields,
        item,
        callback,
      })
    "></Cascader>
          <DatePicker v-else-if="field.component === 'DatePicker'" v-bind="field.bind" v-on="field.on"
            v-model="row[field.key]" :disabled="isMethod(field.disabled, {
              field: field,
              value: row[field.key],
              row,
            })
              " :placeholder="handlePlaceholder(field, { row, field: field })" :style="Object.assign(
    { width: '100%' },
    (field.bind && field.bind.style) || {}
  )
    " @on-change="
    handleMethod({
      methods: field.methods,
      name: 'on-change',
      row,
      rowIndex,
      field,
      fields,
    })
    " transfer></DatePicker>

          <component v-else-if="field.component" :is="
              isMethod(field.component, { row, rowIndex, field, fields }) ||
              'span'
            " v-model="row[field.key]" :row="row" :render="field.render" :field="field" :index="rowIndex"
            v-bind="field.bind" v-on="field.on" :type="isMethod(field.bind && field.bind.type, {
              row,
              rowIndex,
              field,
              fields,
              value: row[field.key],
            })
              " :min="isMethod(field.bind && field.bind.min, {
    row,
    rowIndex,
    field,
    fields,
  })
    " :max="isMethod(field.bind && field.bind.max, {
    row,
    rowIndex,
    field,
    fields,
  })
    " :disabled="isMethod(field.disabled, {
    row,
    rowIndex,
    field,
    fields,
    value: row[field.key],
  })
    " :placeholder="handlePlaceholder(field, { row, rowIndex, field, fields })
    " @click="
    handleMethod({
      methods: field.methods,
      name: field.fnName || 'click',
      row,
      rowIndex,
      field,
      fields,
      value: row[field.key],
    })
    " @on-enter="
    handleMethod({
      methods: field.methods,
      name: 'on-enter',
      row,
      rowIndex,
      field,
      fields,
    })
    " @on-focus="
    handleMethod({
      methods: field.methods,
      name: 'on-focus',
      row,
      rowIndex,
      field,
      fields,
    })
    " @on-blur="
    handleMethod({
      methods: field.methods,
      name: 'on-blur',
      row,
      rowIndex,
      field,
      fields,
    })
    " @on-change="
    handleMethod({
      methods: field.methods,
      name: 'on-change',
      row,
      rowIndex,
      field,
      fields,
      value: row[field.key],
    })
    " @on-ok="
    handleMethod({
      methods: field.methods,
      name: 'on-ok',
      row,
      rowIndex,
      field,
      fields,
    })
    " @on-input="
    handleMethod({
      methods: field.methods,
      name: 'on-input',
      row,
      rowIndex,
      field,
      fields,
    })
    " @on-clear="
    handleMethod({
      methods: field.methods,
      name: 'on-clear',
      row,
      rowIndex,
      field,
      fields,
    })
    " @on-select="
    handleMethod({
      methods: field.methods,
      name: 'on-select',
      row,
      rowIndex,
      field,
      fields,
    })
    " @on-click="
    handleMethod({
      methods: field.methods,
      name: 'on-click',
      row,
      rowIndex,
      field,
      fields,
    })
    ">{{
    $page.handleMethod({
      methods: field.methods,
      name: "render",
      row,
      field,
      value: row[field.key],
    }) || row[field.key]
  }}</component>
          <TableExpand v-else-if="field.render" :row="row" :field="field" :index="rowIndex" :render="field.render"
            v-bind="field.bind"></TableExpand>

          <span v-else :style="[
            isMethod(
              field.bind && field.bind.style,
              { row, field, value: row[field.key] },
              {}
            ),
          ]">{{
  $page.handleMethod({
    methods: field.methods,
    name: "render",
    row,
    field,
    value: row[field.key],
  }) || row[field.key]
}}</span>
          <Button v-if="row[field.key] &&
              isMethod(field.copy, { row, field, value: row[field.key] }, false)
              " @click="fieldCopy({ row, field, value: row[field.key] })" v-bind="field.copyBind" icon="md-copy"
            size="small" style="margin-left: 5px" />
        </component>
      </slot>
    </template>
  </vxe-column>
</template>

<script>
import TableExpand from "./expand";
import { getLetterWidth } from "@/libs/tools.js";
import tableColumnChild from "./table-column-child.vue";
export default {
  components: {
    TableExpand,
    tableColumnChild,
  },
  props: {
    fields: {
      type: Array,
      default: () => [],
    },
    field: {
      type: Object,
      default: () => ({}),
    },
    config: {
      type: Object,
      default: () => ({}),
    },
  },
  inject: {
    $page: "$page",
    $table: "$table",
  },
  data() {
    return {};
  },
  computed: {
    isDeep() {
      return this.field.key ? this.field.key.includes(".") : false;
    },
  },
  methods: {
    openUrl(url) {
      console.log(url);
      window.open(url, "_blank");
    },
    getLetterWidthFun(str, fontSize) {
      return getLetterWidth(str, fontSize);
    },
    hasPermission(id) {
      return this.$hasPermission(id);
    },
    handleDropoDown(index, { fields, row, rowIndex, methods }) {
      let btn = fields.list[index];
      this.$page.handleMethod({
        methods: methods || fields.methods,
        name: btn.fnName || "click",
        field: btn,
        row,
        rowIndex,
        fields: fields.list,
      });
    },
    fieldCopy({ row, field, value }) {
      if (field.methods && field.methods.render) {
        this.$page.copy(field.methods.render({ row, field, value }));
      } else this.$page.copy(row[field.key]);
    },
    allCopy({ field, noFilter }) {
      this.$table.allCopy(field.key, noFilter);
    },
    handleMethod({ methods, name, row, field, fields }) {
      let config = this.$page.config || {};
      if (["on-change"].includes(name)) {
        let mergeRows = config.mergeRows;
        let mergeRow = config.mergeRow;
        if (mergeRows && mergeRows.includes(field.key)) {
          this.$table.list.forEach((t) => {
            if (mergeRow) {
              if (t[mergeRow] === row[mergeRow]) {
                t[field.key] = row[field.key];
              }
            } else {
              t[field.key] = row[field.key];
            }
          });
        }
      }
      if (methods && methods[name])
        return methods[name].call(this.$table, {
          ...arguments[0],
          row,
          fields,
          field,
        });
    },
    handlePlaceholder(item, params) {
      let name = {
        Select: "select",
        DatePicker: "select",
      };
      return this.$page.isMethodDefault(
        item.placeholder,
        params,
        this.isMethod(item.name)
      );
    },
    isMethodDefault(methods, params, df) {
      if (typeof methods === "function")
        return methods.call(this.$table, params);
      return df;
    },
    isMethod(methods, params, df) {
      if (typeof methods === "function")
        return methods.call(this.$table, params);
      return methods !== undefined ? methods : df;
    },
    getProp(item, config, name) {
      return item[config ? config[name] || name : name];
    },
  },
};
</script>

<style scoped></style>
